import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { BrandingProvider } from "@/lib/branding";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import CookieBanner from "@/components/CookieBanner";
import LoginPage from "@/pages/LoginPage";
import KioskPage from "@/pages/KioskPage";
import DashboardPage from "@/pages/DashboardPage";
import TimeClockPage from "@/pages/TimeClockPage";
import UsersPage from "@/pages/UsersPage";
import LocationsPage from "@/pages/LocationsPage";
import SchedulePage from "@/pages/SchedulePage";
import AbsencesPage from "@/pages/AbsencesPage";
import HandoverPage from "@/pages/HandoverPage";
import AnnouncementsPage from "@/pages/AnnouncementsPage";
import TasksPage from "@/pages/TasksPage";
import ChatPage from "@/pages/ChatPage";
import DeliveryPage from "@/pages/DeliveryPage";
import RecipesPage from "@/pages/RecipesPage";
import QMPage from "@/pages/QMPage";
import AuditPage from "@/pages/AuditPage";
import BrandingPage from "@/pages/BrandingPage";
import ReportsPage from "@/pages/ReportsPage";
import SurveysPage from "@/pages/SurveysPage";
import PersonnelPage from "@/pages/PersonnelPage";
import AdminRequestsPage from "@/pages/AdminRequestsPage";
import AdminTimeClockPage from "@/pages/AdminTimeClockPage";
import LegalPage from "@/pages/LegalPage";
import ProfilePage from "@/pages/ProfilePage";
import ShiftExchangePage from "@/pages/ShiftExchangePage";

const withLayout = (Comp, roles) => (
  <ProtectedRoute roles={roles}>
    <Layout><Comp /></Layout>
  </ProtectedRoute>
);

export default function App() {
  return (
    <I18nProvider>
      <BrandingProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
            <CookieBanner />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/kiosk" element={<KioskPage />} />
              <Route path="/legal/:doc_type" element={<LegalPage />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={withLayout(DashboardPage)} />
              <Route path="/timeclock" element={withLayout(TimeClockPage)} />
              <Route path="/schedules" element={withLayout(SchedulePage)} />
              <Route path="/shift-exchange" element={withLayout(ShiftExchangePage)} />
              <Route path="/personnel" element={withLayout(PersonnelPage, ["manager", "admin", "super_admin"])} />
              <Route path="/requests" element={withLayout(AdminRequestsPage, ["manager", "admin", "super_admin"])} />
              <Route path="/admin-timeclock" element={withLayout(AdminTimeClockPage, ["manager", "admin", "super_admin"])} />
              <Route path="/absences" element={withLayout(AbsencesPage)} />
              <Route path="/handover" element={withLayout(HandoverPage)} />
              <Route path="/announcements" element={withLayout(AnnouncementsPage)} />
              <Route path="/surveys" element={withLayout(SurveysPage)} />
              <Route path="/tasks" element={withLayout(TasksPage)} />
              <Route path="/chat" element={withLayout(ChatPage)} />
              <Route path="/delivery" element={withLayout(DeliveryPage)} />
              <Route path="/recipes" element={withLayout(RecipesPage)} />
              <Route path="/qm" element={withLayout(QMPage, ["manager", "admin", "super_admin"])} />
              <Route path="/users" element={withLayout(UsersPage, ["manager", "admin", "super_admin"])} />
              <Route path="/locations" element={withLayout(LocationsPage, ["admin", "super_admin"])} />
              <Route path="/reports" element={withLayout(ReportsPage, ["admin", "super_admin"])} />
              <Route path="/audit" element={withLayout(AuditPage, ["admin", "super_admin"])} />
              <Route path="/branding" element={withLayout(BrandingPage, ["admin", "super_admin"])} />
              <Route path="/profile" element={withLayout(ProfilePage)} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </BrandingProvider>
    </I18nProvider>
  );
}
